import { render } from "./EvalOneToMany.vue?vue&type=template&id=6e908f32&scoped=true"
import script from "./EvalOneToMany.vue?vue&type=script&lang=js"
export * from "./EvalOneToMany.vue?vue&type=script&lang=js"

import "./EvalOneToMany.vue?vue&type=style&index=0&id=6e908f32&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e908f32"]])

export default __exports__